import {Order} from './order';

export class Sort {

  constructor(public orders: Array<Order>) {
  }

}
